import React from "react";
import Svg, { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

type Avatar7Colors = {
  background?: string;
  accessories?: string;
  skin?: string;
};

export const Avatar7 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar7Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    accessories: colors.accessories ?? "#fff",
    skin: colors.skin ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar7" clipPath="url(#clip0_2286_5354)">
        <Path
          id="background"
          d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
          fill={c.background}
        />
        <Path
          id="accessories"
          d="M225.564 136.375c-1.959-9.047.478-90.805-77.585-90.805-57.763 0-72.186 36.1-74.734 66.268 2.93-21.773 13.22-34.062 29.403-34.524 17.003-.478 46.78 24.513 60.04 53.287 9.079 19.695-1.226 52.22-18.763 67.551-13.26 11.587-32.11 15.036-44.487 14.884-5.63-.071-11.914-8.585-18.19-21.749.391 5.137.287 9.851-.668 13.945-2.54 10.887 7.104 22.084 7.104 22.084s-3.035 2.007-5.926 9.143c-3.153 7.772.343 16.254.343 16.254s-4.34.358-12.026 12.87c-2.477 4.03-3.68 7.948-3.854 11.643 17.457 11.946 37.534 20.34 59.188 24.139 33.704-10.648 47.282-41.875 72.09-42.528 27.014-.708 33.393 17.37 33.393 17.37s4.643-11.492.247-24.458c-4.404-12.965-10.09-16.174-10.09-16.174s11.555-20.269 13.268-35.185c1.712-14.917-6.794-54.968-8.753-64.015Z"
          fill={c.accessories}
        />
        <Path
          id="skin"
          d="M72.512 131.716c0 12.567-4.69 19.233-3.026 29.849 9.795 28.679 20.746 51.36 29.96 51.472 12.368.151 31.227-3.298 44.487-14.885 17.537-15.331 27.842-47.856 18.763-67.551-13.26-28.773-43.037-53.764-60.04-53.287-20.587.582-31.641 20.317-30.136 54.394l-.008.008Z"
          fill={c.skin}
        />
        <Path
          id="Vector"
          d="M148.648 120.583s-14.152-3.441-22.259-3.281c-9.533.191-16.287 5.566-18.214 1.592-2.533-5.224 5.503-7.748 19.966-9.325 7.78-.853 14.701 4.221 20.499 11.014h.008Z"
          fill="#000"
        />
        <Path
          id="Vector_2"
          d="M139.083 128.292c-1.529-1.378-3.13-2.764-5.192-3.592-2.533-1.035-5.217-1.346-7.877-1.019-5.901 1.139-10.6 5.845-13.435 10.958 3.226-2.293 6.156-4.38 9.071-5.75a7.346 7.346 0 0 0-.35 2.23c0 4.062 3.233 7.351 7.215 7.351 3.982 0 7.215-3.289 7.215-7.351 0-.653-.087-1.282-.239-1.887.717.382 1.45.82 2.199 1.338 2.867 1.497 6.363.103 8.728-1.641-2.501.303-5.256.884-7.335-.629v-.008Z"
          fill="#000"
        />
        <Path
          id="Vector_3"
          d="M93.083 134.344c-2.357-4.236-6.26-8.147-11.158-9.094-2.206-.271-4.444-.008-6.538.844-1.72.693-3.042 1.839-4.317 2.986-1.728 1.259-4.013.781-6.092.526 1.96 1.441 4.866 2.604 7.247 1.362 2.222-1.513 4.237-2.334 6.133-2.628a5.656 5.656 0 0 0-.399 2.086c0 3.178 2.533 5.758 5.655 5.758 2.723 0 4.993-1.959 5.527-4.563 1.274.828 2.572 1.752 3.942 2.723Z"
          fill="#000"
        />
        <Path
          id="Vector_4"
          d="M88.886 118.393c12.957 19.05-6.347 34.683-1.712 39.485 4.372 4.532 15.928 2.039 15.832 5.503.159 2.533-16.31 4.356-21.2-5.638-1.035-3.704 12.257-26.552 3.058-38.299 1.848 1.696 2.748-1.545 4.022-1.059v.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_5"
          d="M73.364 111.631c11.309-.685 16.557 6.762 15.729 8.259-1.219 2.214-8.84-1.561-16.501-2.214-.215-1.035.756-5.177.772-6.045Z"
          fill="#000"
        />
        <Path
          id="Vector_6"
          d="M160.928 77.625c6.069 4.3 15.673 53.231 4.906 74.264-.263-18.301.908-38.028-4.906-74.264Z"
          fill="#121212"
        />
        <Path
          id="Vector_7"
          d="M192.657 109.568c3.225 11.301-3.425 75.22-42.807 88.345 17.72-16.844 38.594-47.72 42.807-88.345Z"
          fill="#121212"
        />
        <Path
          id="Vector_8"
          d="M206.673 158.515c-8.84 22.586-38.434 83.646-107.163 67.487 44.224 2.787 78.039-20.882 107.163-67.487Z"
          fill="#121212"
        />
        <Path
          id="Vector_9"
          d="M90.885 254.433c4.396 7.056 16.987 11.269 31.394 10.911 15.267-.382 49.56-27.882 74.782-31.378 14.94-2.079 23.915 1.911 23.915 1.911s-7.279-10.13-24.298-8.8c-27.292 2.134-55.875 31.306-76.988 32.326-21.112 1.019-24.552-2.604-28.797-4.97h-.008Z"
          fill="#121212"
        />
        <G id="Clothing" fill="#000">
          <Path
            id="Clothing_2"
            d="M70.067 265.591c7.685-12.512 12.026-12.87 12.026-12.87s-2.071-5.049-1.577-10.927l-36.714 16.717a152.554 152.554 0 0 0 22.418 18.723c.176-3.695 1.378-7.605 3.855-11.635l-.008-.008Z"
          />
          <Path
            id="Clothing_3"
            d="M231.72 253.669c3.361 12.153-.828 22.538-.828 22.538s-6.38-18.078-33.393-17.369c-24.808.653-38.387 31.879-72.082 42.527a152.796 152.796 0 0 0 26.416 2.302c38.872 0 74.336-14.614 101.19-38.649-4.197-2.406-11.762-6.603-21.303-11.349Z"
          />
        </G>
        <Path
          id="Vector_10"
          d="M112.053 175.502c-3.241-.669-6.379-3.329-9.827-3.329-3.449 0-7.877 2.931-7.877 2.931s-.74-2.397-3.982-2.397c-3.241 0-7.693 7.351-7.685 7.383.27.812 2.525 14.343 13.077 14.343 12.201 0 24.083-17.394 25.166-19.01l.048-.072s-5.662.828-8.936.159l.016-.008Zm7.797.693c-4.5 3.934-13.65 10.648-25.835 10.648-5.75 0-7.67-4.309-10.544-6.419-.056-.04-.024-.135.047-.119 1.259.302 5.95 1.353 10.983 1.353 12.185 0 20.387-2.946 25.277-5.574.072-.04.136.055.072.103v.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_2286_5354">
          <Rect width={303.667} height={303.667} fill="#fff" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
